import React from 'react';

/** CONTEXT */
import ThemeContext from '../../context/theme';
/** COMPONENTS */
import { StyledContainer } from './styled';

const Container = ({ children, fluid, ...otherProps }) => {
  const theme = React.useContext(ThemeContext);
  return (
    <StyledContainer {...otherProps} fluid={fluid} theme={theme}>
      {children}
    </StyledContainer>
  );
};

export default Container;
